import { Setting } from '@favid-inc/api';
import React from 'react';
import * as ReactHookForm from 'react-hook-form';

import { SettingsContext } from './context';
import { saveSetting } from './service';

interface SettingFormProps {
  settingKey: Setting['key'];
  label: string;
  type?: string;
}

export const SettingForm: React.FunctionComponent<SettingFormProps> = (props) => {
  const { label, settingKey, type } = props;

  const { register, handleSubmit } = ReactHookForm.useForm();

  const [submitting, setSubmitting] = React.useState<boolean>(false);

  const onSubmit = handleSubmit(async ({ value }) => {
    if (submitting) {
      return;
    }
    try {
      setSubmitting(true);
      await saveSetting({ ...setting, value: JSON.parse(value) });
    } catch (e) {
      alert('Erro ao salvar');
    } finally {
      setSubmitting(false);
    }
  });

  const setting = useSettingValue(settingKey);
  const defaultValue = JSON.stringify(setting.value);

  return (
    <form onSubmit={onSubmit}>
      <div className='ui form'>
        <div className='inline field'>
          <label>{label}</label>
          <input type={type} disabled={submitting} name='value' defaultValue={defaultValue} ref={register} />
          <button type='submit' className={`ui primary button ${submitting && 'loading'}`}>Salvar</button>
        </div>
      </div>
    </form>
  );
};

export function useSettingValue<S extends Setting>(key: S['key']): S {
  const settings = React.useContext(SettingsContext);
  const setting = React.useMemo(() => settings.find((s) => s.key === key), [settings, key]);

  if (!setting || setting?.key !== key) {
    throw new Error();
  }

  return setting as S;
}
